import api from '../services/api';
import { useAuth } from 'react-oidc-context';
import { useState, useEffect } from 'react';

interface UserInfo {
    ID: number;
    user_type: 'member' | 'clerk';
    reference_id: number;
    lastName: string;
    isClerk?: boolean;  // user_typeから派生させる
}

export const useUser = () => {
  const auth = useAuth();
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserInfo = async () => {
      if (!auth.isAuthenticated || !auth.user?.access_token) {
        setIsLoading(false);
        return;
      }

      try {
        const response = await api.get('/users/me', {
          headers: {
            'Authorization': `Bearer ${auth.user.access_token}`,
            'Accept': 'application/json'
          }
        });
        

        if (response.status === 200 && response.data) {
          const userData = response.data;
          userData.isClerk = userData.user_type === 'clerk';
          setUserInfo(response.data);
        }
      } catch (error) {
        console.error('API request failed:', error);
      } finally {
        setIsLoading(false);  // 必ずローディング状態を解除
      }
    };

    fetchUserInfo();
  }, [auth.isAuthenticated, auth.user?.access_token]);

  return {
    userInfo,
    isLoading: isLoading || auth.isLoading,  // auth.isLoadingも考慮
    isAuthenticated: auth.isAuthenticated
  };
};